/**
 * useOutreachCounts — Outreach tab-pill counts (GET
 * /campaigns/{id}/outreach/counts). The BE only registers the outreach
 * routes when the config group is set, so this 404s cleanly in an
 * environment where outreach isn't enabled — callers check the query's
 * `error` for that (see OutreachTab's isOutreachDisabledError).
 */
import { useQuery } from '@tanstack/react-query';
import type { OutreachCounts } from '@discovr/types';
import { campaignKeys } from '../queryKeys';
import { retryOutreachQuery } from './outreachRetry';
import { fetchOutreachCounts } from '../api/outreachApi';

export function useOutreachCounts(campaignId: string) {
  return useQuery<OutreachCounts>({
    queryKey: campaignKeys.outreachCounts(campaignId),
    queryFn: () => fetchOutreachCounts(campaignId),
    enabled: !!campaignId,
    staleTime: 30_000,
    retry: retryOutreachQuery,
  });
}
